import {
    CREATE_DYEING_DC_FAILURE,
    CREATE_DYEING_DC_REQUEST,
    CREATE_DYEING_DC_SUCCESS,
    CREATE_USER_FORM_DYEING_DC,
    FETCH_SINGLE_DYEING_DC_FAILURE,
    FETCH_SINGLE_DYEING_DC_REQUEST,
    FETCH_SINGLE_DYEING_DC_SUCCESS,
    FETCH_DYEING_DC_FAILURE,
    FETCH_DYEING_DC_REQUEST,
    FETCH_DYEING_DC_SUCCESS,
    NAVIGATE_DYEING_DC_DETAILS,
    NAVIGATE_DYEING_DC,
    DYEING_DC_USERFORM_RESET,
    UPDATE_DYEING_DC_FAILURE,
    UPDATE_DYEING_DC_REQUEST,
    UPDATE_DYEING_DC_SUCCESS,
    DELETE_DYEING_DC_REQUEST,
    DELETE_DYEING_DC_SUCCESS,
    DELETE_DYEING_DC_FAILURE,
    DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_DYEING_DC_INVOICE_REQUEST,
    FETCH_DYEING_DC_INVOICE_SUCCESS,
    FETCH_DYEING_DC_INVOICE_FAILURE,
    RESET_DYEING_DC_INVOICE_V2,
    FETCH_DYEING_DC_STYLE_REQUEST,
    FETCH_DYEING_DC_STYLE_SUCCESS,
    FETCH_DYEING_DC_STYLE_FAILURE,
    DYEING_DC_DIA_SUCCESS,
    DYEING_DC_DIA_REQUEST,
    DYEING_DC_DIA_FALIURE,
    DYEING_DC_PROGRAM_ID_SUCCESS,
    DYEING_DC_PROGRAM_ID_FAILURE,
    DYEING_DC_PROGRAM_ID_REQUEST,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_DYEING_DC_PRINT
} from './dyeingDC.actionsType';

export const DYEING_DC = 'dyeingDc';

let initialState = {
    loading: false,
    dyeingDC: [],
    dyeingDCInvoiceV2: [],
    dyeingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldIsReprocess: false,
        fldIsWithCost: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedDyeingDC: {},
    detailsId: '',
    activeKey: 1,
    isDyeingDC: false,
    dyeingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true
};

export let dyeingDcReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    if (type === 'CREATE_DYEING_DC_SUCCESS') {
        localStorage.setItem('DetailStyleIdDye', JSON.stringify(updatePayload));
    }
    switch (type) {
        case FETCH_DYEING_DC_REQUEST:
        case FETCH_DYEING_DC_STYLE_REQUEST:
        case FETCH_DYEING_DC_INVOICE_REQUEST:
        case CREATE_DYEING_DC_REQUEST:
        case FETCH_SINGLE_DYEING_DC_REQUEST:
        case UPDATE_DYEING_DC_REQUEST:
        case DELETE_DYEING_DC_REQUEST:
        case DYEING_DC_DIA_REQUEST:
        case DYEING_DC_PROGRAM_ID_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDC: updatePayload
            };
        case FETCH_DYEING_DC_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDCStyle: updatePayload?.PONO
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                loading: false,
                ...state,
                headerSearchCall: payload
            }
        case FETCH_DYEING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDCInvoiceV2: updatePayload
            };

        case DYEING_DC_DIA_SUCCESS:
            return {
                ...state,
                diaListStyle: updatePayload
            };
        case CREATE_DYEING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_DYEING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedDyeingDC: updatePayload,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }
            };
        case DYEING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram
            };
        case UPDATE_DYEING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedDyeingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case DELETE_DYEING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedDyeingDC: {}
            };
        case FETCH_DYEING_DC_FAILURE:
        case FETCH_DYEING_DC_STYLE_FAILURE:
        case FETCH_DYEING_DC_INVOICE_FAILURE:
        case FETCH_SINGLE_DYEING_DC_FAILURE:
        case CREATE_DYEING_DC_FAILURE:
        case UPDATE_DYEING_DC_FAILURE:
        case DELETE_DYEING_DC_FAILURE:
        case DYEING_DC_DIA_FALIURE:
        case DYEING_DC_PROGRAM_ID_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_DYEING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case DYEING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldIsReprocess: false,
                    fldIsWithCost: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                selectedDyeingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_DYEING_DC_DETAILS:
            return {
                ...state,
                isDyeingDC: true,
                dyeingDCSelectedValue: updatePayload.dyeingDCSelectedValue
            };
        case NAVIGATE_DYEING_DC:
            return {
                ...state,
                isDyeingDC: false
            };
        case NAVIGATE_DYEING_DC_PRINT:
            return {
                ...state,
                isDyeingDC: false,
                loading: false,
                dyeingDCSelectedValue: updatePayload.dyeingDCSelectedValue
            };
        case RESET_DYEING_DC_INVOICE_V2:
            return {
                ...state,
                dyeingDCInvoiceV2: []
            };
        case DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };
        case DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
